import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";

import Info from "./home_info";
import Schedule from "./home_sched";
import Sections from "./home_sections";
// import Classes from "./home_classes";
import Features from "./home_features";
import Contacts from "./home_contacts";

export default function KickboxingHome() {
  useEffect(() => {
    document.title =
      "London Kickboxing classes, personal training, self-defence and fitness";
    document.getElementsByTagName("META")[5].content =
      "london kickboxing provides kickboxing classes in london, personal training, self defence, martial arts and fitness for men women and children";
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div className="bg-black text-white">
      {/* style={{backgroundImage: "./public/bg1.png"}} */}
      {/* Hero Section */}
      <br />
      <section className="lkbxbg1 container py-5">
        <div className="row align-items-center">
          <div className="col-md-6 backg1">
            <img
              src="./img/hero.png"
              alt="kickboxing"
              className="img-fluid rounded"
              width="450px"
            />
            <br />
            <br />
          </div>
          <div className="col-md-6">
            <p>
              <img
                src="./img/lkbx_logo.png"
                alt="kickboxing"
                className="img-fluid"
              />
            </p>
            <h1 className="fw-bold display-5">
              Kickboxing in London <br />
              <span className="text-danger">For All Levels</span>
            </h1>
            <div className="d-flex gap-3">
              <button className="btn btn-danger" onClick={handleShow}>
                Book a Free Trial
              </button>
              <a
                href="#sched"
                title="View Schedule<"
                className="btn btn-light"
                role="button"
              >
                &nbsp;View Schedule&nbsp;
              </a>
              <a
                href="https://www.fastdd.co.uk/platinum/start.php?c=London-Kickboxing"
                target="_blank"
                rel="noreferrer"
                title="FastDD Online Direct Debit Portal"
                className="btn btn-danger"
                role="button"
              >
                &nbsp;Join Now&nbsp;
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Features */}
      <Features />

      {/* Classes */}
      <Sections />

      {/* <section className="retrobg container py-5">
        <h2 className="text-center fw-bold mb-4">Our Classes</h2>
        <Classes />
      </section> */}

      <div id="sched"></div>

      {/* Schedule */}
      <Schedule />

      {/* Contacts */}
      <Contacts />

      {/* Info */}
      <Info />

      {/* Get in Touch */}
      <section className="lkbxbg5 container py-5">
        <h2 className="text-center fw-bold mb-4">Get in Touch</h2>
        <div className="text-center">
          Interested in learning how our kickboxing academy in Acton and
          Chiswick can help you to achieve your fitness and martial arts goals?
          <br />
          Get in touch today by calling{" "}
          <a href="tel:+447779593335" title="Call +447779593335">
            <strong>07779593335</strong>
          </a>{" "}
          or email &nbsp;
          <a
            href="mailto:info@londonkickboxing.co.uk"
            title="email londonkickboxing"
          >
            <strong>info@londonkickboxing.co.uk</strong>
          </a>
        </div>
      </section>
      {/* Testimonials */}
      {/* <section className="bg-danger container text-center py-5">
        <h3 className="fw-bold">What Our Members Say</h3>
        <p className="mt-3">
          “Amazing training! Great atmosphere and awesome instructors.”
        </p>
      </section> */}
      {/* Modal */}
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>BOOK A FREE TRIAL SESSION</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          Call{" "}
          <a href="tel:+447779593335" title="Call +447779593335">
            <strong>07779593335</strong>
          </a>{" "}
          or email to&nbsp;
          <a
            href="mailto:info@londonkickboxing.co.uk"
            title="email londonkickboxing"
          >
            <strong>info@londonkickboxing.co.uk</strong>
          </a>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
